<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="s in settings" :key="s.id" cols="4">
        <third-party-setting-input
          v-model="s.content"
          :label="s.name"
          :setup-name="value.name"
          :setting-name="s.name"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-container>
      <v-row align="center" justify="center">
        <v-btn color="primary" @click="saveSettings" text
          >Save "{{ this.value.name }}" Settings</v-btn
        >
      </v-row>
    </v-container>
    <v-row v-if="debug">
      <v-col>
        <code>{{ setup }}</code>
        <code>{{ ownerSetup }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import ThirdPartySettingInput from "./ThirdPartySettingInput.vue";
const CREATE_MUTATION = gql`
  mutation createThirdPartySetup($input: ThirdPartySetupInput!) {
    createThirdPartySetup(input: $input) {
      id
      name
      level
      inUse
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateThirdPartySetup($input: ThirdPartySetupInput!) {
    updateThirdPartySetup(input: $input) {
      id
      name
      level
      inUse
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteThirdPartySetup($id: ID!) {
    deleteThirdPartySetup(id: $id) {
      id
    }
  }
`;
const OWNER_SETUP_QUERY = gql`
  query ownerSetup(
    $ownerId: ID
    $level: ThirdPartySetupLevel
    $name: String
    $inUse: Boolean
  ) {
    thirdPartySetups(
      filter: {
        ownerId_eq: $ownerId
        level_eq: $level
        name_eq: $name
        inUse_eq: $inUse
      }
    ) {
      edges {
        node {
          id
          name
          ownerId
          settings {
            edges {
              node {
                id
                name
                content
              }
            }
          }
        }
      }
    }
  }
`;
export default {
  name: "third-party-setup-for-owner",
  components: { ThirdPartySettingInput },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    ownerId: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      debug: false,
      settings: this.value ? this.getSettings() : [],
    };
  },

  computed: {
    setup() {
      return {
        id: this.ownerSetup ? this.ownerSetup.id : undefined,
        name: this.value.name,
        inUse: this.value.inUse,
        level: this.value.level,
        ownerId: this.ownerId,
        settings: this.settings.map((s) => ({
          name: s.name,
          content: s.content,
        })),
      };
    },
    ownerSetup() {
      //console.log(this.thirdPartySetups);
      return this.thirdPartySetups &&
        this.thirdPartySetups.edges &&
        this.thirdPartySetups.edges.length > 0
        ? { ...this.thirdPartySetups.edges[0].node }
        : null;
    },
  },

  methods: {
    getSettings() {
      return this.value.settings.edges.map(removeGQLTypename).map((s) => {
        const found = this.ownerSetup
          ? this.ownerSetup.settings.edges.find((os) => os.node.name === s.name)
          : null;
        return {
          id: found ? found.node.id : s.id,
          name: s.name,
          content: found ? found.node.content : s.content,
        };
      });
    },
    saveSettings() {
      const mutation = this.setup.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: this.setup },
          refetchQueries: [
            {
              query: OWNER_SETUP_QUERY,
              variables: {
                ownerId: this.ownerId,
                level: this.value.level,
                name: this.value.name,
                inUse: true,
              },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Third Party Setup Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    thirdPartySetups: {
      query: OWNER_SETUP_QUERY,
      variables() {
        return {
          ownerId: this.ownerId,
          level: this.value.level,
          name: this.value.name,
          inUse: true,
        };
      },
      fetchPolicy: "network-only",
      result({ data }) {
        if (data && data.thirdPartySetups && data.thirdPartySetups.edges) {
          this.settings = this.getSettings();
        }
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/third-party-setups/ThirdPartySetupForOwner.vue